import {Keys, StorageService} from '../service/storage.service';
import {FileService} from '../service/file.service';
import {FileDetails} from '../model/file-details.model';
import {Injectable} from '@angular/core';

@Injectable()
export class FileInteractor {

    constructor(private storageService: StorageService, private fileService: FileService) {
    }

    public async upload(files: any) {
        const userId = this.storageService.getItem(Keys.PROFILE_ID);
        return await this.fileService.upload(userId, files);
    }

    public async getMetadata(fileId: string): Promise<FileDetails> {
        return await this.fileService.getFileData(fileId);
    }
}
